import React from 'react';
import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/react';
import { useSmartCase } from '@/modules/footer';
import type { TimezoneOption } from '../timezone';

interface TimezoneSelectProps {
  timezone: string;
  setTimezone: (value: string) => void;
  timezones: readonly TimezoneOption[];
  lines?: 'full' | 'inset' | 'none';
  /** The row's label, in sentence case; shown as `useSmartCase` cases it. */
  label?: string;
  className?: string;
  'data-testid'?: string;
}

/** The topic's time zone picker, as a labelled row in a section card. */
const TimezoneSelect: React.FC<TimezoneSelectProps> = ({
  timezone,
  setTimezone,
  timezones,
  lines = 'none',
  label = 'Time zone',
  className,
  'data-testid': testId = 'timezone-select',
}) => {
  const smartCase = useSmartCase();
  return (
    <IonItem lines={lines} className={className}>
      <IonLabel>{smartCase(label)}</IonLabel>
      <IonSelect
        value={timezone}
        interface="popover"
        onIonChange={e => setTimezone(e.detail.value as string)}
        data-testid={testId}
      >
        {timezones.map(tz => (
          <IonSelectOption key={tz.value} value={tz.value}>
            {tz.label}
          </IonSelectOption>
        ))}
      </IonSelect>
    </IonItem>
  );
};

export default TimezoneSelect;
